/** @jsxImportSource @emotion/react */
import React from 'react'
import {MagazineForm, MagazinePreview} from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/MagazineContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, manageMagazine } = breadcrumbItems

const ManageNews: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageMagazine]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <MagazineForm />
        </div>
        <div css={styles.right}>
          <MagazinePreview />
        </div>
      </div>
    </Provider>
  )
}

export default ManageNews
